import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import ProjectCard from "./ProjectCards";
import Particle from "../Particle";

// استدعاء صور المشاريع الأربعة
import novaImg from "../../Assets/Projects/nova.png";
import ecomImg from "../../Assets/Projects/ecom.png";
import ticketImg from "../../Assets/Projects/ticket.png";
import ebookImg from "../../Assets/Projects/ebook.png";

function Projects() {
  return (
    <Container fluid className="project-section">
      <Particle />
      <Container>
        <h1 className="project-heading">
          My Recent <strong className="purple">Works </strong>
        </h1>
        <p style={{ color: "white" }}>
          A showcase of integrated digital solutions and high-performance applications.
        </p>
        <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
          
          {/* 1. Nova SaaS */}
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={novaImg}
              isBlog={false}
              title="Nova SaaS Platform"
              description="A scalable multi-tenant SaaS solution designed for business automation. Built with a focus on high-availability architecture, featuring advanced user management and custom workspace configurations."
               demoLink="https://nova.wageh.net/"
            />
          </Col>

          {/* 2. Full-Stack E-Commerce */}
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={ecomImg}
              isBlog={false}
              title="Advanced E-Commerce"
              description="A high-performance online store with a fully decoupled architecture. It features a reactive frontend integrated with a secure Laravel 12 RESTful API, optimized for speed and seamless UX."
              demoLink="https://store.wageh.net/"
            />
          </Col>

          {/* 3. Ticket Support System */}
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={ticketImg}
              isBlog={false}
              title="Ticket Management System"
              description="A professional helpdesk and support ticketing system. Engineered to streamline client requests and internal task tracking, featuring real-time status updates and priority-based workflows."
              demoLink="https://ticket.wageh.net/"
            />
          </Col>

          {/* 4. Pricing & Freelance Guide */}
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={ebookImg}
              isBlog={false}
              title="Freelance Strategy Guide"
              description="A digital product and automated sales funnel for developers. Integrated with Paymob payment gateway API, showcasing expertise in Fintech integrations and digital asset distribution."
              demoLink="https://ebook.wageh.net/"
            />
          </Col>

        </Row>
      </Container>
    </Container>
  );
}

export default Projects;